module.exports = __webpack_public_path__ + "img/Logo.d926d07a.png";